module.exports = __webpack_public_path__ + "static/media/jeans-two.84741828.jpeg";